import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer" className="py-24 relative overflow-hidden" data-id="element-170">
      {/* Dramatic background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-171"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-172">
        <FadeIn data-id="element-173">
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-174">
            Recupera tu valor
          </h2>
          <p className="text-2xl md:text-3xl text-gray-300 font-light mb-12" data-id="element-175">
            y haz que él sea quien{' '}
            <span className="text-gold-400 italic font-serif" data-id="element-176">
              pierda el sueño por ti.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-177">
          <div className="bg-dark-100 border border-gold-500/30 p-8 md:p-12 rounded-sm shadow-[0_0_40px_rgba(0,0,0,0.5)] max-w-2xl mx-auto" data-id="element-178">
            <p className="text-xl text-white mb-6" data-id="element-179">
              Obtén el sistema completo de "El Efecto Sombra" hoy mismo.
            </p>

            <div className="mb-8" data-id="element-180">
              <span className="text-gray-400 text-sm uppercase tracking-widest mb-2 block" data-id="element-181">
                Precio exclusivo de lanzamiento
              </span>
              <div className="flex items-center justify-center gap-4" data-id="element-182">
                <span className="text-3xl font-serif text-gray-500 line-through decoration-red-400/60 decoration-2" data-id="element-183">
                  $27
                </span>
                <div className="text-6xl font-serif text-gold-400 font-bold text-glow" data-id="element-184">
                  $6.39 <span className="text-2xl text-gold-500/70" data-id="element-185">USD</span>
                </div>
              </div>
              <span className="inline-block mt-3 px-3 py-1 bg-red-500/20 border border-red-500/30 text-red-400 text-sm font-medium rounded-sm tracking-wide" data-id="element-186">
                76% DE DESCUENTO
              </span>
            </div>

            <Button href="https://claveviva.com/cart/43192054415478:1" className="w-full md:w-auto mb-6 text-xl py-5 px-10" onClick={trackAddToCart} data-id="element-187">
              ¡QUIERO QUE ME PERSIGA!
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-188">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-189" />
              <span data-id="element-190">
                Acceso instantáneo después del pago. Formato PDF apto para
                cualquier dispositivo.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}